import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\CreateMultipleDraftFromDocument::__invoke
* @see app/Http/Controllers/ModelNotification/CreateMultipleDraftFromDocument.php
* @route '/api/notification/multiple/create-from-pdf'
*/
const CreateMultipleDraftFromDocument = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateMultipleDraftFromDocument.url(options),
    method: 'post',
})

CreateMultipleDraftFromDocument.definition = {
    methods: ["post"],
    url: '/api/notification/multiple/create-from-pdf',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ModelNotification\CreateMultipleDraftFromDocument::__invoke
* @see app/Http/Controllers/ModelNotification/CreateMultipleDraftFromDocument.php
* @route '/api/notification/multiple/create-from-pdf'
*/
CreateMultipleDraftFromDocument.url = (options?: RouteQueryOptions) => {
    return CreateMultipleDraftFromDocument.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\CreateMultipleDraftFromDocument::__invoke
* @see app/Http/Controllers/ModelNotification/CreateMultipleDraftFromDocument.php
* @route '/api/notification/multiple/create-from-pdf'
*/
CreateMultipleDraftFromDocument.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateMultipleDraftFromDocument.url(options),
    method: 'post',
})

export default CreateMultipleDraftFromDocument